import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface FloatingNodesProps {
  className?: string;
  count?: number;
}
export function FloatingNodes({
  className = '',
  count = 15
}: FloatingNodesProps) {
  const [nodes, setNodes] = useState<Array<{
    id: number;
    x: number;
    y: number;
    size: number;
    duration: number;
    delay: number;
  }>>([]);
  useEffect(() => {
    const newNodes = Array.from({
      length: count
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 30 + 10,
      duration: Math.random() * 10 + 15,
      delay: Math.random() * 5
    }));
    setNodes(newNodes);
  }, [count]);
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-36">
      {nodes.map(node => <motion.div key={node.id} className="absolute rounded-full bg-sky-200/20 backdrop-blur-sm border border-sky-300/30" style={{
      left: `${node.x}%`,
      top: `${node.y}%`,
      width: node.size,
      height: node.size
    }} animate={{
      y: [0, -30, 0],
      x: [0, 15, 0],
      opacity: [0.3, 0.6, 0.3]
    }} transition={{
      duration: node.duration,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: node.delay
    }} data-id="element-37" />)}

      {/* Decorative connecting lines (static for performance, could be animated SVG) */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.03] pointer-events-none" data-id="element-38">
        <path d="M100,100 Q400,300 700,100 T1200,400" fill="none" stroke="currentColor" strokeWidth="2" className="text-sky-900" data-id="element-39" />
        <path d="M-100,600 Q300,400 600,800 T1400,500" fill="none" stroke="currentColor" strokeWidth="2" className="text-sky-900" data-id="element-40" />
      </svg>
    </div>;
}